import { createSelector } from 'reselect';

import { AppState } from '../../store/store';
import { ChangePasswordFormValues } from '../pages/modals/change-password/models/change-password-form-values';
import { ChangePasswordState } from './change-password-reducer';

const changePasswordState = (state: AppState): ChangePasswordState => state.changePassword;

export const changePasswordSelector = createSelector(changePasswordState, changePasswordModal => ({
    isOpen: changePasswordModal.isChangePasswordModalOpen,
    hasError: changePasswordModal.hasError,
    initialValues: {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirmation: '',
    } as ChangePasswordFormValues,
}));
